// extracted by mini-css-extract-plugin
module.exports = {"container":"FinancialReleases_container__17w90","title":"FinancialReleases_title__3fK_3","content":"FinancialReleases_content__1Pfbw","empty":"FinancialReleases_empty__lLIKW"};